import React from "react";
import PropTypes from "prop-types";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  LabelList,
} from "recharts";
import styles from "./NrSufficiencyGraph.module.css";

const BAR_COLOR = "#3F51D7";

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) {
    return null;
  }

  const row = payload[0].payload;

  return (
    <div className={styles.tooltip}>
      <div className={styles.tooltipTitle}>
        {row["Immediate Source"]}
      </div>

      <div className={styles.tooltipValue}>
        NR Sufficiency : {row["Immediate Source Per"]}%
      </div>
    </div>
  );
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
};

CustomTooltip.defaultProps = {
  active: false,
  payload: [],
};

const NRSufficiencyGraph = ({ data, loading }) => {
  if (loading) {
    return (
      <div className={styles.shimmerWrapper}>
        <div className={styles.shimmerChart} />
      </div>
    );
  }

  if (!data?.length) {
    return <div className={styles.centerState}>No Data</div>;
  }

  const chartWidth = data.length > 12 ? `${data.length * 65}px` : "100%";

  return (
    <div className={styles.graphContainer}>
      <div className={styles.horizontalScroll}>
        <div
          className={styles.chartWrapper}
          style={{ width: chartWidth }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              margin={{
                top: 35,
                right: 20,
                left: 10,
                bottom: 20,
              }}
            >
              <CartesianGrid
                vertical
                horizontal={false}
                stroke="#E5E7EB"
              />

              <XAxis
                dataKey="Immediate Source"
                interval={0}
                tick={{
                  fontSize: 11,
                  fill: "#4B5563",
                }}
                angle={-35}
                textAnchor="end"
                height={45}
              />

              <YAxis
                domain={[0, 110]}
                tickFormatter={(v) => `${v}%`}
                tick={{
                  fontSize: 12,
                  fill: "#6B7280",
                }}
              />

              <Tooltip content={<CustomTooltip />} />

              <Bar
                dataKey="Immediate Source Per"
                radius={[6, 6, 0, 0]}
                barSize={42}
              >
                <LabelList
                  dataKey="Immediate Source Per"
                  position="top"
                  offset={8}
                  fill="#374151"
                  fontSize={11}
                  fontWeight={600}
                  formatter={(value) =>
                    value > 0 ? `${value}%` : ""
                  }
                />

                {data.map((item) => (
                  <Cell
                    key={item["Immediate Source"]}
                    fill={BAR_COLOR}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

NRSufficiencyGraph.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      "Immediate Source": PropTypes.string,
      "Immediate Source Per": PropTypes.number,
    }),
  ),
  loading: PropTypes.bool,
};

NRSufficiencyGraph.defaultProps = {
  data: [],
  loading: false,
};

export default NRSufficiencyGraph;